import moment from 'moment';

/**
 * Helper pour la gestion des dates avec moment.js notamment.
 */
export class DateHelper {
    public static formatDateParDefaut: string = 'YYYY-MM-DD';

    /**
     * Créer une date à partir de l'année, du mois et du jour.
     * @param annee L'année.
     * @param mois Le mois.
     * @param jour Le jour.
     */
    public static creerDate(annee: number, mois: number, jour: number): string {
        return moment(`${annee}-${mois}-${jour}`, DateHelper.formatDateParDefaut).format(DateHelper.formatDateParDefaut);
    }

    /**
     * Vérifie qu'on peut faire une date valide à partir de l'année, du mois et du jour.
     * @param annee L'année.
     * @param mois Le mois.
     * @param jour Le jour.
     */
    public static dateValide(annee: number, mois: number, jour: number): boolean {
        const date = moment(`${annee}-${mois}-${jour}`, DateHelper.formatDateParDefaut);
        return date.isValid();
    }

    /**
     * Convertit une date au format DD/MM/YYYY.
     * @param date : la date à traiter
     */
    public static format(date: string) {
        if (!date) {
            return undefined;
        }

        return moment(date).format('DD/MM/YYYY');
    }

    /**
     * Convertit une date au format paramétré.
     * @param date : la date à traiter
     */
    public static formatParam(date: string, format: string) {
        moment.locale('fr');
        if (!date) {
            return undefined;
        }

        return moment(date).format(format);
    }

    /**
     * Récupère le nombre de jours d'un mois donné.
     * @param annee L'année.
     * @param mois Le mois.
     */
    public static getJoursDansLeMois(annee: number, mois: number) {
        return moment(this.creerDate(annee, mois, 1)).daysInMonth();
    }


    /**
       * Vérifie si une date est dans le futur
       */
    public static isInFuture(date?: Date | null): boolean {
        if (!date) return false
        return date.getTime() > Date.now()
    }

    /**
     * Vérifie si une date est dans le passé
     */
    public static isInPast(date?: Date | null): boolean {
        if (!date) return false
        return date.getTime() < Date.now()
    }

    /**
     * Nombre de jours avant une date
     * - null si date absente
     * - 0 si date passée
     */
    public static daysBefore(date?: Date | null): number | null {
        if (!date) return null

        const diffMs = date.getTime() - Date.now()
        if (diffMs <= 0) return 0

        return Math.ceil(diffMs / (1000 * 60 * 60 * 24))
    }



    /**
     * Parse une date ISO (string) ou Date de manière sécurisée
     * @returns Date ou null si invalide
     */
    public static parseISODate(
        input?: string | Date | null
    ): Date | null {
        if (!input) return null

        if (input instanceof Date) {
            return isNaN(input.getTime()) ? null : input
        }

        if (typeof input === 'string') {
            const parsed = new Date(input)
            return isNaN(parsed.getTime()) ? null : parsed
        }

        return null
    }

}
